





























import { Component, Vue, Prop } from "vue-property-decorator";

import BSwitch from "@/components/app/switchs/b-switch.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({ components: { StandartModal, BSwitch } })
export default class CinemaPlayerType extends Vue {
  @Prop({ type: String, default: "" }) player!: string;

  defautl_list = ["HCAPVideoPlayer", "HTML5VideoPlayer", "VideoJS"];
}
